import template from './prems-discount-category-list.html.twig';
import './prems-discount-category-list.scss';

const { Criteria } = Shopware.Data;

Shopware.Component.register('prems-discount-category-list', {
    template: template,

    inject: ['repositoryFactory'],

    data() {
        return {
            items: null,
            isLoading: false
        }
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('prems_discount_category_base');
        },

        criteria() {
            const criteria = new Criteria(1, 25);
            return criteria;
        },

        columns() {
            return [
                {
                    property: 'name',
                    dataIndex: 'name',
                    label: this.$tc('prems-discount-category.list.grid.columns.nameLabel')
                },
                {
                    property: 'active',
                    dataIndex: 'active',
                    label: this.$tc('prems-discount-category.list.grid.columns.statusLabel')
                },
                {
                    property: 'priority',
                    dataIndex: 'priority',
                    label: this.$tc('prems-discount-category.list.grid.columns.priorityLabel')
                },
                {
                    property: 'validFrom',
                    dataIndex: 'validFrom',
                    label: this.$tc('prems-discount-category.list.grid.columns.validFromLabel')
                },
                {
                    property: 'validUntil',
                    dataIndex: 'validUntil',
                    label: this.$tc('prems-discount-category.list.grid.columns.validUntilLabel')
                },
                {
                    property: 'discount',
                    dataIndex: 'discount',
                    label: this.$tc('prems-discount-category.list.grid.columns.discountLabel')
                }
            ];
        },
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },
        dateFilter() {
            return Shopware.Filter.getByName('date');
        },
    },

    created() {
        this.isLoading = true;
        this.getList();
    },

    methods: {
        onCreate() {
            this.$router.push({ name: 'prems.discount.category.create' });
        },
        getList() {
            this.isLoading = true;
            return this.repository.search(this.criteria, Shopware.Context.api)
                .then(items => {
                    this.items = items;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        onDuplicate(item) {
            this.isLoading = true;
            const behavior = {
                cloneChildren: true,
                overwrites: {
                    name: `${item.name} ${this.$tc('global.default.copy')}`,
                    active: false,
                    numberOfOrders: 0
                },
            };
            this.repository.clone(item.id, behavior, Shopware.Context.api).then((discountCategory) => {
                this.getList();
                this.isLoading = false;
                this.$router.push(
                    {
                        name: 'prems.discount.category.detail',
                        params: { id: discountCategory.id },
                    },
                );
            });
        },

        onChangeLanguage(languageId) {
            Shopware.Store.get('context').setApiLanguageId(languageId);
            this.getList();
        },

        getItemStatus(item) {
            const now = Date.now();
            if (item.validUntil) {
                const until = new Date(item.validUntil).getTime();
                if (until < now) {
                    return 2;
                }
            }

            return item.active ? 1 : 0;
        }
    }
});
